import { Flex, Icon, Tag, Text } from '@core/ui-elements'
import { FC } from 'react'
import { IconType } from 'react-icons'
import { MdCircle } from 'react-icons/md'

export const CounterTag: FC<{
  amount?: number
  total: number
  label: string
  icon?: IconType
  color?: string
  bg?: string
  amountWithColor?: boolean
  size?: 'xs' | 'sm' | 'md' | 'lg'
}> = ({
  amount,
  total,
  label,
  icon = MdCircle,
  color,
  bg,
  amountWithColor = false,
  size = 'sm',
}) => {
  return (
    <Tag
      backgroundColor={bg ?? 'white'}
      fontWeight={'600'}
      size={size}
      variant="subtle"
    >
      <Flex
        alignItems={'center'}
        flexDirection={'row'}
        gap={'0.25rem'}
        lineHeight={'1rem'}
      >
        {icon && (
          <Icon
            as={icon}
            color={color}
            data-testid={icon.name}
            fontSize={icon === MdCircle ? '0.5rem' : '0.75rem'}
          />
        )}
        {amount || amount === 0 ? (
          <Flex alignItems={'center'}>
            <Text as="span" color={amountWithColor ? color : 'gray.800'}>
              {amount}
            </Text>
            /{total}
          </Flex>
        ) : (
          total
        )}{' '}
        {label}
      </Flex>
    </Tag>
  )
}
